import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-12 gap-8 md:gap-12">
          <div className="col-span-12 md:col-span-5">
            <p className="text-overline mb-6">
              <span className="kb-counter mr-2">N&deg; 05</span> Contact
            </p>
            <h2 className="font-serif-display font-medium text-[#0f172a] tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
              Begin a
              <span className="block italic text-[#1a362d]">conversation.</span>
            </h2>
            <span className="block mt-6 gold-rule-solid" />
            <p className="mt-8 text-[#475569] text-base md:text-lg leading-relaxed max-w-md">
              For new matters and consultations, the most direct path is by
              telephone. All formal engagements are initiated through Tomchak
              Skolout.
            </p>
          </div>

          <div className="col-span-12 md:col-span-7 md:pl-10">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-[#bfa15f]/30 border border-[#bfa15f]/30">
              <a
                href="tel:8015024017"
                data-testid="contact-phone"
                className="bg-[#fdfbf7] px-7 py-9 group hover:bg-[#fffdf6] transition-colors"
              >
                <div className="flex items-center gap-3 text-[#bfa15f] mb-5">
                  <Phone className="w-4 h-4" strokeWidth={1.6} />
                  <span className="text-overline">By Telephone</span>
                </div>
                <p className="font-serif-display text-3xl md:text-4xl text-[#0f172a] tracking-tight leading-none">
                  801.502.4017
                </p>
                <span className="block mt-5 text-[0.72rem] uppercase tracking-[0.22em] text-[#475569] group-hover:text-[#1a362d] transition-colors">
                  Tap to dial &rarr;
                </span>
              </a>

              <a
                href="https://www.tomchakskolout.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-firm"
                className="bg-[#fdfbf7] px-7 py-9 group hover:bg-[#fffdf6] transition-colors"
              >
                <div className="flex items-center gap-3 text-[#bfa15f] mb-5">
                  <MapPin className="w-4 h-4" strokeWidth={1.6} />
                  <span className="text-overline">Of Counsel — Firm</span>
                </div>
                <p className="font-serif-display text-3xl md:text-[2.1rem] text-[#0f172a] tracking-tight leading-tight">
                  Tomchak Skolout
                </p>
                <span className="block mt-5 text-[0.72rem] uppercase tracking-[0.22em] text-[#475569] group-hover:text-[#1a362d] transition-colors">
                  Visit firm &rarr;
                </span>
              </a>

              <div className="bg-[#fdfbf7] px-7 py-9 sm:col-span-2">
                <div className="flex items-center gap-3 text-[#bfa15f] mb-5">
                  <Mail className="w-4 h-4" strokeWidth={1.6} />
                  <span className="text-overline">A Note on Engagement</span>
                </div>
                <p className="text-[#334155] text-[15px] md:text-base leading-relaxed max-w-2xl">
                  Initial communications do not establish an attorney-client
                  relationship. Please do not send confidential information
                  until a formal engagement has been confirmed in writing
                  through the firm.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
